import React from 'react'
import { useStateValue } from '../StateProvider'
import './Checkout.css'
import Subtotal from './Subtotal'
import CheckoutProduct from './CheckoutProduct'

function Checkout() {
    const [{ cart }] = useStateValue(); 
    return (
        <div className="checkout">
            <div className="checkout__left">
                <a href="https://amazon.in"><img className="checkout__ad" src = "https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB423492668_.jpg" alt=""></img></a>
                {cart.length === 0 ? (
                    <div>
                        <h2>Your Amazon Cart is empty</h2>
                        <small className="todays__deals">The price and availability of items at Amazon.in are subject to change. The shopping cart is a temporary place to store a list of your items and reflects each item's most recent price.
                        
                        <p></p>
                        Do you have a promotional code? We'll ask you to enter your claim code when it's time to pay.</small>                
                    </div>
                ) : (
                    <div>
                        <h2 className="checkout__name">Your Shopping Cart</h2>
                    
                        {
                                cart.map(item => (
                                    <CheckoutProduct
                                    id={item.id}
                                    name={item.name}
                                    image={item.image}
                                    price={item.price}
                                    rating={item.rating}
                                    previousPrice={item.previousPrice}
                                    />
                                ))
                                    
                        }
                    </div>    
                    )
                }
            </div>
            {(cart.length> 0) && (
                <div className = "checkout__subtotal">
                  <Subtotal />
                </div>    
            )}
        </div>
    )
}

export default Checkout
